module.exports = __webpack_public_path__ + "img/banner-web.2.d1f725eb.png";